module.exports = __webpack_public_path__ + "media/images/training/training_session-1bd53ff9ab777d104ee16f4682ad13d3.jpg";